module.exports = __webpack_public_path__ + "static/media/vc-presentation.733681e6.jpeg";